export enum ReportIssueType {
  BrokenLink = 1,
  IncorrectData = 2,
  Other = 3,
}

export const ReportIssueTypeList = [
  ReportIssueType.BrokenLink,
  ReportIssueType.IncorrectData,
  ReportIssueType.Other,
];
